import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

import { useAdRefresh } from '../../hooks';

import { DisplayAdProfileLeaderboard } from './leaderboard-ad';

const AdWrapper = styled.div`
  min-width: 728px;
  max-width: 970px;
  height: 90px;
  position: relative;
  z-index: 1;
`;

export const DisplayAdProfileLeaderboardSlot: React.FC = () => {
  const isSmallScreen = useMatchMedia(mediaSmallOrTiny);

  const { refreshDesktop } = useAdRefresh({
    isSmallScreen,
    slots: {
      mobile: '',
      desktop: 'leaderboard',
    },
  });

  if (isSmallScreen) {
    return null;
  }

  return (
    <AdWrapper>
      <NoSSR>
        <DisplayAdProfileLeaderboard refresh={refreshDesktop} />
      </NoSSR>
    </AdWrapper>
  );
};
